import React from "react"

const debug = false
// const debug = "FieldSelectFields_InlineValueNotEmpty"

export default function FieldSelectFields_InlineValueNotEmpty(props:any) {

    debug && console.log(debug, 'render', props.value)

    const onDelete = (fieldId:ID) => {
        props.onChange(gd.utils.toggleArrayValue(props.value, fieldId))
    }

    const selectedFields = _.map(props.value, fieldId=>props.field.fields.get(fieldId))

    const classes = Classes("ui5-txt-no-accent-default ui5-field-dropdown-inline-editable max-w-300 fl-wrap", props.className, {
        "m-t-4 m-b-4": !props.field.noDefaultPaddingMargin
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {_.map(selectedFields, field =>
                    <props.field.components.Pill key        = {field.fieldId}
                                                 className  = "m-r-10 m-t-4 m-b-4"
                                                 field      = {field}
                                                 onDelete   = {onDelete}/>
                )}
            </div>
            {props.children}
        </React.Fragment>
    )
}
